import {
  GeoMatchStatusEnum,
  JobPhaseBumpApprovalStatus,
} from '@vatos-pas/common';

export const JOB_PHASE_BUMP_APPROVAL_STATUS_LABEL_MAPPING = {
  [JobPhaseBumpApprovalStatus.MISMATCH_APPROVAL]: 'Mismatch Approval',
  [JobPhaseBumpApprovalStatus.APPROVED]: 'Approved',
  [JobPhaseBumpApprovalStatus.NOT_STARTED]: 'Not Started',
  [JobPhaseBumpApprovalStatus.OVERRIDDEN]: 'Overriden',
  [JobPhaseBumpApprovalStatus.PENDING_APPROVAL]: 'Pending Approval',
  [JobPhaseBumpApprovalStatus.PENDING_REVIEW]: 'Pending Review',
  [JobPhaseBumpApprovalStatus.DEPRECATED]: 'Deprecated',
};

export const GEO_STATUS_NULL_SENTINEL = '__NULL__';

export const LOCATION_STATUS_FILTER_CHOICES: { val: string; text: string }[] = [
  { val: GeoMatchStatusEnum.MATCH, text: 'Valid' },
  { val: GeoMatchStatusEnum.MISMATCH, text: 'Out of Bounds' },
  { val: GeoMatchStatusEnum.JOB_GEOLOCATION_NOT_FILLED, text: 'Address Issue' },
  { val: GEO_STATUS_NULL_SENTINEL, text: 'No GPS' },
];
